import { useContext } from "react"
import { AppContext } from "../context/context"

const UiButton2 = ({text, submit}) => {

	const { dataFetchLoading } = useContext(AppContext)

	return(
		<div 
		style={{cursor: "pointer"}}
		onClick={dataFetchLoading? null : submit}
		className="button2  d-flex ">

			<div 
			 className="d-flex justify-content-center"
			style={{border: "1px solid white", width: 39, height: 39, borderRadius: "100px"}}>
				<div style={{width: "15px"}} className="align-self-center ">
					<img src={ "/src/arrow.png"} style={{width: "100%", transform: "scale(-1, 1)"}}/>
				</div>
				
			</div>
			<div className="align-self-center d-flex justify-content-start flex-grow-1">
				<p className="fs-6 text-white mb-0 align-self-center ms-2">{text}</p>
			</div>
			
			

		</div>
	)
}

export default UiButton2